import * as academyTypes from './academy.type';

const initialState = {
  academyList: [],
  academyCategoryList: [],
  academyDetailList: [],
  academyListFiltered: [],
  error: null,
  isLoading: false,
};

const reducer = (state = initialState, { type, payload, ...params }) => {
  switch (type) {
    case `${academyTypes.GET_ACADEMY_LIST_PENDING}`:
    case `${academyTypes.POST_ACADEMY_CATEGORY_FILTER_PENDING}`:
    case `${academyTypes.GET_ACADEMY_CATEGORY_LIST_PENDING}`:
    case `${academyTypes.GET_ACADEMY_DETAIL_LIST_PENDING}`:
    case `${academyTypes.SAVE_QUESTION_ANSWER_PENDING}`:
      return { ...state, isLoading: true, error: null };

    // Academy List
    case `${academyTypes.GET_ACADEMY_LIST_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        academyList: payload.data,
      };
    case `${academyTypes.GET_ACADEMY_LIST_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        academyList: [],
      };

    // Academy List Filter By Id
    case `${academyTypes.POST_ACADEMY_CATEGORY_FILTER_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        academyListFiltered: payload.data,
      };
    case `${academyTypes.POST_ACADEMY_CATEGORY_FILTER_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        academyListFiltered: [],
      };

    // Academy Category List
    case `${academyTypes.GET_ACADEMY_CATEGORY_LIST_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        academyCategoryList: payload.data.content,
      };
    case `${academyTypes.GET_ACADEMY_CATEGORY_LIST_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        academyCategoryList: [],
      };

    // Academy Detail List
    case `${academyTypes.GET_ACADEMY_DETAIL_LIST_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        academyDetailList: payload.data,
      };
    case `${academyTypes.GET_ACADEMY_DETAIL_LIST_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        academyDetailList: [],
      };

    // Save Question Answer
    case `${academyTypes.SAVE_QUESTION_ANSWER_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
      };
    case `${academyTypes.SAVE_QUESTION_ANSWER_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };

    default:
      return state;
  }
};

export default reducer;
